import React from 'react';
import { RichHtml } from './RichHtml';
import type { Question } from '../../services/examApi';

interface QuestionViewProps {
  question: Question;
  /** 选择题当前选中 label / 填空当前值 / FRQ 各子问值 */
  answer: any;
  onChange: (value: any) => void;
}

export const QuestionView: React.FC<QuestionViewProps> = ({ question, answer, onChange }) => {
  return (
    <div className="space-y-5">
      {question.passage?.html && (
        <RichHtml html={question.passage.html} className="prose max-w-none text-gray-800 leading-relaxed" />
      )}

      {question.question?.html && (
        <RichHtml html={question.question.html} className="prose max-w-none font-medium text-gray-900" />
      )}

      {/* 选择题 */}
      {question.type === 'choice' && question.options && (
        <div className="space-y-2">
          {question.options.map((opt) => {
            const selected = answer === opt.label;
            return (
              <button
                key={opt.label}
                onClick={() => onChange(opt.label)}
                className={`w-full text-left flex items-start gap-3 rounded-xl border px-4 py-3 transition ${
                  selected
                    ? 'border-primary-500 bg-primary-50'
                    : 'border-gray-200 hover:border-primary-300 hover:bg-primary-50/40'
                }`}
              >
                <span
                  className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-semibold ${
                    selected ? 'bg-primary-500 text-white' : 'bg-gray-100 text-gray-600'
                  }`}
                >
                  {opt.label}
                </span>
                <RichHtml html={opt.html} className="prose max-w-none flex-1 pt-0.5" />
              </button>
            );
          })}
        </div>
      )}

      {/* 填空题（SAT student-produced response，无 parts） */}
      {question.type === 'response' && !question.parts?.length && (
        <div>
          <input
            type="text"
            className="input max-w-xs"
            placeholder="Enter your answer"
            value={answer ?? ''}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
      )}

      {/* FRQ（AP，含子问 parts） */}
      {question.type === 'response' && question.parts?.length ? (
        <div className="space-y-5">
          {question.parts.map((p) => (
            <div key={p.index} className="space-y-2">
              <div className="flex items-start gap-2">
                {p.label && (
                  <span className="shrink-0 font-semibold text-primary-700">{p.label}</span>
                )}
                <RichHtml html={p.html} className="prose max-w-none flex-1" />
              </div>
              <textarea
                className="input"
                rows={4}
                placeholder="Write your response…"
                value={(answer && answer[p.index]) ?? ''}
                onChange={(e) => onChange({ ...(answer || {}), [p.index]: e.target.value })}
              />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};
